module.exports = __webpack_public_path__ + "static/media/rubik-v14-latin-700.72b25070.ttf";